<template>
  <b-card
    :class="{ 'clickable' : hasSrc }"
    :img-src="src"
    class="thumbnail">

    <div class="card-img-overlay">
      <span v-if="hasSrc" class="empty icon">
        <i class="fas fa-play fa-3x"></i>
      </span>
      <span v-else class="empty">
        <i class="fas fa-file-video fa-3x"></i>
      </span>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    hasSrc () {
      return this.src.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.thumbnail {
  width: 24rem;
  max-width: 100%;
  background: $light-secondary;

  .card-body {
    padding: 0 !important;
    text-align: center;

    .empty {
      line-height: 12rem;
    }
  }
  
  .icon {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate( -50%, -50% );
    z-index: 500;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/video-preview.vue